import { getJSON } from 'bv-fetch';
import { locale } from 'bv-i18n';

export default () => getJSON('/home', {
  c: locale(),
});
